import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientGfrLabs(patientId: string | undefined) {
  return useQuery(queries.patients.getPatientGfrs(patientId || ''))
}
